import metadata from "../assets/tracks-metadata.generated.json";

export enum Genre {
  AMBIENT = "Ambient",
  DEEP_HOUSE = "Deep House",
  BASS_HOUSE = "Bass House",
  KWAITO = "Kwaito",
  DANCE_BASS_HOUSE = "Dance Bass House",
  DARK_BASS_HOUSE = "Dark Bass House",
  GOTHIC_BASS_HOUSE = "Gothic Bass House",
  DARK_DEEP_HOUSE = "Dark Deep House",
  CINEMATIC = "Cinematic",
}

export interface Track {
  title: string;
  genre: Genre[];
  durationSeconds: number;
  fileName: string;
}

const TRACK_DEFS: Omit<Track, "durationSeconds">[] = [
  {
    title: "Movement Detected",
    genre: [Genre.AMBIENT, Genre.DEEP_HOUSE],
    fileName: "Movement Detected.mp3",
  },
  { title: "Suite 304", genre: [Genre.AMBIENT, Genre.BASS_HOUSE], fileName: "Suite 304.mp3" },
  { title: "Blacklist", genre: [Genre.BASS_HOUSE, Genre.KWAITO], fileName: "Blacklist.mp3" },
  {
    title: "Prime Era",
    genre: [Genre.DANCE_BASS_HOUSE, Genre.KWAITO],
    fileName: "Prime Era.mp3",
  },
  {
    title: "Lioness Ritual",
    genre: [Genre.DARK_BASS_HOUSE, Genre.KWAITO],
    fileName: "Lioness Ritual.mp3",
  },
  {
    title: "Sky Weds Sunset",
    genre: [Genre.DEEP_HOUSE, Genre.BASS_HOUSE],
    fileName: "Sky Weds Sunset.mp3",
  },
  { title: "Hooked on You", genre: [Genre.DEEP_HOUSE], fileName: "Hooked on You.mp3" },
  // Disk filename casing differs from display title
  {
    title: "Give Me Your Hand",
    genre: [Genre.DEEP_HOUSE, Genre.KWAITO],
    fileName: "Give me your hand.mp3",
  },
  {
    title: "Gothic",
    genre: [Genre.GOTHIC_BASS_HOUSE, Genre.DARK_DEEP_HOUSE, Genre.CINEMATIC],
    fileName: "Gothic.mp3",
  },
];

const durationMap = new Map(
  (metadata as Array<{ fileName: string; durationSeconds: number }>).map((m) => [
    m.fileName,
    m.durationSeconds,
  ]),
);

export const TRACKS: Track[] = TRACK_DEFS.map((def) => ({
  ...def,
  durationSeconds: durationMap.get(def.fileName) ?? 0,
}));
